import { render } from "./bottomNavigationBar.vue?vue&type=template&id=127e045e&scoped=true"
import script from "./bottomNavigationBar.vue?vue&type=script&lang=js"
export * from "./bottomNavigationBar.vue?vue&type=script&lang=js"

import "./bottomNavigationBar.vue?vue&type=style&index=0&id=127e045e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127e045e"]])

export default __exports__